<template>
  <div class="AddRole">
    <div class="titleBox">
      <el-page-header v-if="isAdd" @back="goBack" :content="isAddContent">
      </el-page-header>
      <el-page-header v-else @back="goBack" :content="isEditContent">
      </el-page-header>
    </div>
    <AppBox class="appBox">
      <el-form
          v-show="isShow"
          ref="form"
          :model="formData"
          :rules="rules"
          label-width="100px"
          @submit.prevent
      >
        <el-form-item label="部门">
          <el-select
              style="width: 40%"
              v-model="formData.assistDepartId"
              v-scroll="loadMore"
              placeholder="请选择"
          >
            <el-option
                v-for="item in options"
                :key="item.id"
                :label="item.name"
                :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="角色" prop="name">
          <el-input
              maxlength="8"
              show-word-limit
              style="width: 40%"
              v-model="formData.name"
              @keydown.enter.prevent
          ></el-input>
        </el-form-item>
        <div style="position: relative">
          <el-form-item
              v-if="formData.assistRoleMaterial"
              class="introduce"
              style="width: 100%"
              label="岗位职责"
              v-loading="introduceLoading"
              element-loading-text="加载中，请勿操作..."
              element-loading-spinner="el-icon-loading"
              element-loading-background="rgba(255, 255, 255, 0.8)"
          >
            <quill-editor
                ref="quillEditor"
                :class="
                introduceWarning || blankWarning
                  ? 'warningEditor'
                  : 'defaultEditor'
              "
                :options="editorOptions"
                v-model="formData.assistRoleMaterial.introduce.audioText"
                @change="handleChange"
            ></quill-editor>

            <div v-if="introduceWarning" class="warningTxt">
              转音频文字不得超过300字
            </div>
            <div v-if="blankWarning" class="warningTxt">请输入</div>
          </el-form-item>
          <div
              style="
              position: absolute;
              left: 85%;
              top: 0;
              width: 70px;
              overflow: hidden;
            "
          >
            <input type="file" style="" @change="handleImport"/>
          </div>
        </div>
        <el-form-item label="">
          <div class="toolsBox">
            <!--            左边部分-->
            <div>
              <!--              音频组件-->
              <div
                  class="audioBox"
                  v-if="formData.assistRoleMaterial.introduce.materialUrl"
              >
                <div>
                  <audio
                      :src="formData.assistRoleMaterial.introduce.materialUrl"
                      :loop="false"
                      controls
                      preload="auto"
                      controlsList="nodownload noplaybackrate"
                      ref="audioRef"
                  ></audio>
                </div>
                <div
                    style="margin-left: 30px; display: flex; align-items: center"
                >
                  <i
                      class="el-icon-edit-outline"
                      style="
                      color: #10689c;
                      font-size: 20px;
                      font-weight: bold;
                      cursor: pointer;
                    "
                      @click="handlePolyPhoneModal"
                  ></i
                  ><i
                    class="el-icon-delete"
                    style="
                      color: #10689c;
                      font-size: 20px;
                      font-weight: bold;
                      cursor: pointer;
                      margin-left: 15px;
                    "
                    @click="handleDeleteAudio"
                ></i>
                </div>
              </div>
            </div>
            <!--            右边按钮-->
            <div>
              <MaterialPicker
                  materialType="audio"
                  @onConfirmPickMaterial="onConfirmPickAudio"
              ></MaterialPicker>
              <el-button size="mini" type="primary" @click="handleCreatAudio"
              >生成音频
              </el-button>
            </div>
          </div>
        </el-form-item>
        <el-form-item
            v-if="formData.assistRoleMaterial"
            class="taskDesc"
            label="任务日程"
            v-loading="taskDescLoading"
            element-loading-text="加载中，请勿操作..."
            element-loading-spinner="el-icon-loading"
            element-loading-background="rgba(255, 255, 255, 0.8)"
        >
          <el-upload
              action="#"
              :show-file-list="false"
              :auto-upload="false"
              :on-success="handleImageSuccess"
              :on-change="handleImgChange"
              :before-upload="beforeImageUpload"
          >
            <div style="display: flex; align-items: flex-end">
              <div>
                <img v-if="imageUrl" :src="imageUrl" class="avatar" alt=""/>
                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
              </div>
              <div>
                <el-button
                    class="btn"
                    v-if="imageUrl"
                    size="mini"
                    plain
                    type="primary"
                    slot="trigger"
                >重新上传
                </el-button>
                <MaterialPicker
                    materialType="image"
                    @onConfirmPickMaterial="onConfirmPickMaterial"
                ></MaterialPicker>
              </div>
            </div>
          </el-upload>
          <quill-editor
              ref="quillEditorTaskDesc"
              :class="taskDescWarning ? 'warningEditor' : 'defaultEditor'"
              :options="editorOptions"
              v-model="formData.assistRoleMaterial.taskDesc.audioText"
              @change="handleChangeTaskDesc"
          ></quill-editor>
          <div v-if="taskDescWarning" class="warningTxt">
            转音频文字不得超过300字
          </div>
        </el-form-item>
        <el-form-item label="">
          <div class="toolsBox">
            <!--            左边部分-->
            <div>
              <!--              音频组件-->
              <div
                  class="audioBox"
                  v-if="formData.assistRoleMaterial.taskDesc.materialUrl"
              >
                <div>
                  <audio
                      :src="formData.assistRoleMaterial.taskDesc.materialUrl"
                      :loop="false"
                      controls
                      preload="auto"
                      controlsList="nodownload noplaybackrate"
                      ref="audioRef"
                  ></audio>
                </div>
                <div
                    style="margin-left: 30px; display: flex; align-items: center"
                >
                  <i
                      class="el-icon-edit-outline"
                      style="
                      color: #10689c;
                      font-size: 20px;
                      font-weight: bold;
                      cursor: pointer;
                    "
                      @click="handlePolyPhoneModalTaskDesc"
                  ></i
                  ><i
                    class="el-icon-delete"
                    style="
                      color: #10689c;
                      font-size: 20px;
                      font-weight: bold;
                      cursor: pointer;
                      margin-left: 15px;
                    "
                    @click="handleDeleteAudioTaskDesc"
                ></i>
                  <!--                  <el-button-->
                  <!--                    size="mini"-->
                  <!--                    type="primary"-->
                  <!--                    @click="handleDeleteAudioTaskDesc"-->
                  <!--                    >清除音频-->
                  <!--                  </el-button>-->
                </div>
              </div>
            </div>
            <!--            右边按钮-->
            <div>
              <!--              <el-button-->
              <!--                size="mini"-->
              <!--                type="primary"-->
              <!--                @click="handlePolyPhoneModalTaskDesc"-->
              <!--                >多音字-->
              <!--              </el-button>-->
              <el-button
                  size="mini"
                  type="primary"
                  @click="handleCreatAudioTaskDesc"
              >生成音频
              </el-button>
            </div>
          </div>
        </el-form-item>
      </el-form>
      <CorrectPolyPhoneModal
          v-if="type === 1"
          @refreshInputVal="refreshInputVal"
          :inputValArr="inputValArr"
      ></CorrectPolyPhoneModal>
      <CorrectPolyPhoneModal
          v-if="type === 2"
          @refreshInputVal="refreshInputValTaskDesc"
          :inputValArr="inputValArr"
      ></CorrectPolyPhoneModal>
      <div class="footer" v-show="isShow">
        <el-button
            style="margin-right: 40px; width: 150px"
            type="primary"
            @click="handleConfirm"
        >保存查看
        </el-button>
        <el-button
            style="margin-right: 40px; width: 150px"
            type="primary"
            @click="handleNext"
        >下一步
        </el-button>
        <el-button
            v-if="isAdd"
            style="width: 150px"
            type="primary"
            @click="handleAdd"
        >继续新增
        </el-button>
      </div>
    </AppBox>
  </div>
</template>

<script>
import AppBox from "@/components/ui/AppBox/index.vue";
import {roleMixins} from "@/pages/RoleManagement/roleMixins";
import {mapActions, mapMutations, mapState} from "vuex";
import {quillEditor} from "vue-quill-editor";
import CorrectPolyPhoneModal from "@/pages/RoleManagement/CorrectPolyPhoneModal.vue";
import MaterialPicker from "@/pages/MaterialCenter/components/MaterialPicker.vue";

export default {
  name: "AddRole",
  components: {MaterialPicker, CorrectPolyPhoneModal, AppBox, quillEditor},
  mixins: [roleMixins],
  data() {
    return {
      isAdd: true,
      isShow: false,
      isAddContent: "角色管理 | 新增角色",
      isEditContent: "角色管理 | 编辑角色",
      options: [
        {
          id: 0,
          name: "其他",
        },
      ],
      //   岗位职责开始
      introduceLoading: false,
      introduceWarning: false,
      blankWarning: false,
      editorOptions: {
        placeholder: "请使用文字/上传文档一键导入",
      },
      //   岗位职责结束
      inputValArr: [],
      textLength: null,
      type: 1,
      //   任务开始
      taskDescLoading: false,
      taskDescWarning: false,
      textLengthTaskDesc: null,
      //   任务结束
    };
  },
  computed: {
    ...mapState("fuzhu", ["buMenList"]),
    ...mapState("courseCenter", ["audioDetail"]),
    ...mapState("tenant", ["ossUploadObj"]),
  },
  async mounted() {
    await this.getBuMenList({
      page: 1,
      size: 10,
    });
    this.options = this.options.concat(this.formatData(this.buMenList.data));
    if (this.$route.params.type === "add") {
      this.clearForm();
      if (this.$route.params.assistDepartId) {
        this.formData.assistDepartId = this.$route.params.assistDepartId;
      }
      this.isAdd = true;
    }
    if (this.$route.params.type === "edit") {
      this.isAdd = false;
      const roleDetail = JSON.parse(localStorage.getItem("roleDetail"));
      Object.keys(this.formData).map((key) => {
        this.formData[key] = roleDetail[key];
      });
      this.imageUrl = roleDetail.assistRoleMaterial.taskImage.materialUrl;
    }
    this.isShow = true;
    this.disabledEdit();
    this.blurEditor();
  },
  beforeDestroy() {
    this.distinguishSetData({key: "polyPhoneModalVisible", value: false});
  },
  watch: {
    textLength: {
      handler: function (newValue, oldVal) {
        if (newValue !== oldVal) {
          // this.introduceWarning = newValue > 300;
          this.blankWarning = newValue === 0;
        }
      },
      deep: true,
      immediate: true,
    },
    textLengthTaskDesc: {
      handler: function (newValue, oldVal) {
        if (newValue !== oldVal) {
          this.taskDescWarning = newValue > 300;
        }
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    ...mapActions("fuzhu", ["getBuMenList", "readDocument"]),
    ...mapMutations("teachingCenter", ["setData"]),
    ...mapMutations("polyPhone", ["distinguishSetData"]),
    ...mapActions("courseCenter", ["getAudioUrl"]),
    ...mapActions("tenant", ["generalUploadUrl"]),
    onConfirmPickMaterial(item) {
      this.imageUrl = item.url;
      this.formData.assistRoleMaterial.taskImage.materialId = item.id;
    },
    onConfirmPickAudio(item) {
      this.formData.assistRoleMaterial.introduce.materialId = item.id;
      this.formData.assistRoleMaterial.introduce.materialUrl = item.url;
    },
    // 职责开始
    handleChange() {
      this.inputValArr = this.convertToObjects(
          this.formData.assistRoleMaterial.introduce.audioText
      );
      this.textLength = this.inputValArr.length;
      this.$nextTick(() => {
        this.disabledEdit();
      });
    },
    // 上传任务图片
    handleImageSuccess(res, file) {
      this.imageUrl = URL.createObjectURL(file.raw);
    },
    async handleImgChange(file) {
      this.imageUrl = URL.createObjectURL(file.raw);
      await this.generalUploadUrl({
        contentType: file.raw.type,
      });
      const fileName = encodeURIComponent(file.raw.name);
      this.formData.assistRoleMaterial.taskImage.filename =
          this.ossUploadObj.filename;
      const obj = {
        "Content-Disposition": "attachment;filename=" + '"' + fileName + '"',
        "Content-Type": file.raw.type,
      };
      this.$axios.defaults.withCredentials = false;
      await this.$axios({
        url: this.ossUploadObj.url,
        method: "put",
        isUpload: true,
        data: file.raw,
        headers: obj,
      })
          .then((res) => {
            console.log(res);
          })
          .catch((e) => {
            console.log(e);
          });
      this.$axios.defaults.withCredentials = true;
    },
    beforeImageUpload(file) {
      const isJPG = file.type === "image/jpeg" || file.type === "image/png";
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isJPG) {
        this.$message.error("上传图片只能是 JPG/PNG!");
      }
      if (!isLt2M) {
        this.$message.error("上传图片大小不能超过 2MB!");
      }
      return isJPG && isLt2M;
    },
    async handleImport(event) {
      let file = event.target.files[0];
      let isLt15M = file.size / 1024 / 1024 < 15;
      if (!isLt15M) {
        this.$message.warning("上传文件大小不得超过15MB");
        return;
      }
      isLt15M = null;
      // 处理选择的文件
      if (file.name.endsWith(".doc") || file.name.endsWith(".docx")) {
        const data = new FormData();
        data.append("file", file);
        this.formData.assistRoleMaterial.introduce.audioText =
            await this.readDocument(data);
        this.$message.success("识别成功");
        this.$nextTick(() => {
          this.blurEditor();
        });
      } else {
        this.$message.warning("请选择Word文件进行导入");
      }
      file = null;
    },
    handleDeleteAudio() {
      this.$confirm("请确认是否要清除当前音频内容?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
          .then(async () => {
            this.formData.assistRoleMaterial.introduce.audioText = "";
            this.formData.assistRoleMaterial.introduce.audioSsmlText = "";
            this.formData.assistRoleMaterial.introduce.materialUrl = "";
            this.formData.assistRoleMaterial.introduce.filename = "";
            this.formData.assistRoleMaterial.introduce.duration = null;
          })
          .catch(() => {
          });
    },
    handlePolyPhoneModal() {
      this.type = 1;
      if (this.inputValArr.length < 1 || this.inputValArr.length > 300) {
        return;
      }
      this.inputValArr = this.convertToObjects(
          this.formData.assistRoleMaterial.introduce.audioText
      );
      this.distinguishSetData({key: "polyPhoneModalVisible", value: true});
    },
    async handleCreatAudio() {
      // 生成拼音汉字对象数组
      this.inputValArr = this.convertToObjects(
          this.formData.assistRoleMaterial.introduce.audioText
      );
      if (this.inputValArr.length < 1) {
        return;
      }

      if (this.inputValArr.length > 300) {
        this.$message.warning("暂不支持生成300字以上的长文本，请自行上传音频")
        return;
      }

      this.introduceLoading = true;
      // 生成富文本样式
      const inputText = this.creatQuillText(this.inputValArr);
      // 回显到input输入框
      this.refreshInputVal(inputText);
      //   生成ssml文本
      this.formData.assistRoleMaterial.introduce.audioSsmlText =
          this.creatSsmlText(this.inputValArr);
      // 调接口生成音频
      try {
        await this.getAudioUrl({
          text: this.formData.assistRoleMaterial.introduce.audioSsmlText,
          speechRate: 1.0,
          voice: "zhiyuan",
        });
        // 媒体名称
        this.formData.assistRoleMaterial.introduce.filename =
            this.audioDetail.filename;
        // 媒体ID
        this.formData.assistRoleMaterial.introduce.materialId =
            this.audioDetail.materialId;
        // 音频时长
        const audio = document.createElement("video");
        audio.src = this.audioDetail.url;
        audio.addEventListener("loadedmetadata", () => {
          if (Math.floor(audio.duration) === 0) {
            this.formData.assistRoleMaterial.introduce.duration = 1;
          } else {
            this.formData.assistRoleMaterial.introduce.duration = Math.floor(
                audio.duration
            );
          }
        });
        // 媒体url
        this.formData.assistRoleMaterial.introduce.materialUrl =
            this.audioDetail.url;
      } finally {
        this.introduceLoading = false;
      }
    },
    // 选择多音字发音弹框确定按钮传过来的富文本编辑器回显inputVal
    refreshInputVal(audioText) {
      this.formData.assistRoleMaterial.introduce.audioText = audioText;
      this.$nextTick(() => {
        this.disabledEdit();
        this.blurEditor();
      });
    },
    // 职责结束
    // 任务开始
    handleChangeTaskDesc() {
      this.inputValArr = this.convertToObjects(
          this.formData.assistRoleMaterial.taskDesc.audioText
      );
      this.textLengthTaskDesc = this.inputValArr.length;
      this.$nextTick(() => {
        this.disabledEdit();
      });
    },
    handleDeleteAudioTaskDesc() {
      this.$confirm("请确认是否要清除当前音频内容?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
          .then(async () => {
            this.formData.assistRoleMaterial.taskDesc.audioText = "";
            this.formData.assistRoleMaterial.taskDesc.audioSsmlText = "";
            this.formData.assistRoleMaterial.taskDesc.materialUrl = "";
            this.formData.assistRoleMaterial.taskDesc.filename = "";
            this.formData.assistRoleMaterial.taskDesc.duration = null;
          })
          .catch(() => {
          });
    },
    handlePolyPhoneModalTaskDesc() {
      this.type = 2;
      if (this.inputValArr.length < 1 || this.inputValArr.length > 300) {
        return;
      }
      this.inputValArr = this.convertToObjects(
          this.formData.assistRoleMaterial.taskDesc.audioText
      );
      this.distinguishSetData({key: "polyPhoneModalVisible", value: true});
    },
    async handleCreatAudioTaskDesc() {
      // 生成拼音汉字对象数组
      this.inputValArr = this.convertToObjects(
          this.formData.assistRoleMaterial.taskDesc.audioText
      );
      if (this.inputValArr.length < 1 || this.inputValArr.length > 300) {
        return;
      }
      this.taskDescLoading = true;
      // 生成富文本样式
      const inputText = this.creatQuillText(this.inputValArr);
      // 回显到input输入框
      this.refreshInputValTaskDesc(inputText);
      //   生成ssml文本
      this.formData.assistRoleMaterial.taskDesc.audioSsmlText =
          this.creatSsmlText(this.inputValArr);
      // 调接口生成音频
      try {
        await this.getAudioUrl({
          text: this.formData.assistRoleMaterial.taskDesc.audioSsmlText,
          speechRate: 1.0,
          voice: "zhiyuan",
        });
        // 媒体名称
        this.formData.assistRoleMaterial.taskDesc.filename =
            this.audioDetail.filename;
        // 媒体ID
        this.formData.assistRoleMaterial.taskDesc.materialId =
            this.audioDetail.materialId;
        // 音频时长
        const audio = document.createElement("video");
        audio.src = this.audioDetail.url;
        audio.addEventListener("loadedmetadata", () => {
          if (Math.floor(audio.duration) === 0) {
            this.formData.assistRoleMaterial.taskDesc.duration = 1;
          } else {
            this.formData.assistRoleMaterial.taskDesc.duration = Math.floor(
                audio.duration
            );
          }
        });
        // 媒体url
        this.formData.assistRoleMaterial.taskDesc.materialUrl =
            this.audioDetail.url;
      } finally {
        this.taskDescLoading = false;
      }
    },
    // 选择多音字发音弹框确定按钮传过来的富文本编辑器回显inputVal
    refreshInputValTaskDesc(audioText) {
      this.formData.assistRoleMaterial.taskDesc.audioText = audioText;
      this.$nextTick(() => {
        this.disabledEdit();
        this.blurEditor();
      });
    },
    // 任务结束
    async loadMore() {
      const currentPage = this.buMenList.page;
      const currentSize = this.buMenList.size;
      const currentTotal = this.buMenList.total;
      if (currentPage * currentSize < currentTotal) {
        await this.getBuMenList({
          page: this.buMenList.page + 1,
        });
        this.options = this.options.concat(this.buMenList.data);
      }
    },
    formatData(val) {
      let newVal = [];
      val.map((item, index) => {
        newVal[index] = {
          id: item.id,
          name: item.name,
        };
      });
      return newVal;
    },
    goBack() {
      this.setData({key: "isBack", value: true});
      this.$router.go(-1);
    },
    // 解析为富文本
    creatQuillText(val) {
      return val
          .map((item, index) => {
            if (item.pinyin !== "") {
              if (index % 2 === 0) {
                return `<b style='color: #10689c;'> [${item.pinyin}]${item.cha} </b>`;
              } else {
                return `<b style='color: #10689c;background: transparent;'> [${item.pinyin}]${item.cha} </b>`;
              }
            } else {
              if (item.cha === " ") {
                return "&nbsp;";
              } else {
                return item.cha;
              }
            }
          })
          .join("");
    },
    // 解析为ssml文本，生成音频
    creatSsmlText(val) {
      const ssmlText = val
          .map((item) => {
            if (item.pinyin !== "") {
              return `<phoneme alphabet='py' ph='${item.pinyin}'>${item.cha}</phoneme>`;
            } else {
              return item.cha;
            }
          })
          .join("");
      return "<speak>" + ssmlText + "</speak>";
    },
    // 返回纯文本数组
    convertToObjects(val) {
      let objects = [];
      if (!val) {
        return objects;
      }
      const regex = /(<strong.*?>.*?<\/strong>)|./g;
      const result = val.match(regex);
      var newResult = [];
      for (let i = 0; i < result.length; i++) {
        if (result[i].trim().length > 1) {
          if (!result[i].includes("color: rgb(16, 104, 156)")) {
            const div = document.createElement("div");
            div.innerHTML = result[i];
            let text = div.textContent || div.innerText;
            newResult.push(text);
          } else {
            const div = document.createElement("div");
            div.innerHTML = result[i];
            let text = div.textContent || div.innerText;
            newResult.push("{{{" + text + "}}}");
          }
        } else {
          newResult.push(result[i]);
        }
      }
      const str = newResult.join("");
      const div = document.createElement("div");
      div.innerHTML = str;
      let newStr = div.textContent || div.innerText;

      const regex2 = /({{{.*?}}})|./g;
      const result2 = newStr.match(regex2);
      for (let i = 0; i < result2.length; i++) {
        const item = result2[i];
        if (item.length > 1) {
          const regex = /\{\{\{(.+?)\}\}\}/g;
          const match = item.replace(regex, "$1");
          if (match && match.length >= 2) {
            const extractedText = match.trim();
            const cha = extractedText.split("]")[1];
            const pinyin = extractedText.split("]")[0].split("[")[1];
            objects.push({cha: cha, pinyin: pinyin});
          }
        } else {
          objects.push({cha: item, pinyin: ""});
        }
      }
      if (objects.every((item) => item.cha === " ")) {
        objects = [];
      }
      return objects;
    },
    // 多音字不可编辑部分
    disabledEdit() {
      let paragraphs = document.querySelectorAll("p");
      paragraphs.forEach(function (paragraph) {
        let strongArr = paragraph.querySelectorAll("strong");
        strongArr.forEach(function (strong) {
          strong.setAttribute("contenteditable", "false");
        });
      });
    },
    //   输入框失去焦点
    blurEditor() {
      this.$nextTick(() => {
        const editor = this.$refs.quillEditor.quill;
        const length = editor.getLength();
        editor.setSelection(length, length);
        editor.blur();
        const editorTaskDesc = this.$refs.quillEditorTaskDesc.quill;
        const lengthTaskDesc = editorTaskDesc.getLength();
        editorTaskDesc.setSelection(lengthTaskDesc, lengthTaskDesc);
        editorTaskDesc.blur();
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../styles/variables";

.AddRole {
  .titleBox {
    background: white;
    border-radius: 2px;
    padding: 20px;
    margin-bottom: 20px;
    display: flex;
    justify-content: space-between;
    align-items: center;

    ::v-deep .el-page-header__left {
      color: map-get($colors, primary);
    }
  }

  .appBox {
    width: 100%;
    height: calc(100vh - 155px);
    overflow-y: auto;

    .introduce {
      ::v-deep .el-form-item__label::before {
        content: "*";
        color: #f56c6c;
        margin-right: 4px;
      }
    }

    .introduce,
    .taskDesc {
      ::v-deep .ql-toolbar.ql-snow {
        display: none;
      }

      margin-bottom: 10px !important;

      ::v-deep .ql-container.ql-snow {
        border: none;
      }

      ::v-deep .ql-editor {
        width: 100%;
        border: none;
        border-radius: 4px;
        height: 150px !important;
        background: #ffffff;
      }

      ::v-deep .defaultEditor {
        width: 80%;
        border: 1px solid #dcdfe6;
        border-radius: 4px;
      }

      ::v-deep .warningEditor {
        width: 80%;
        border-radius: 4px;
        border: 1px solid #f56c6c;
      }

      .warningTxt {
        color: #f56c6c;
        font-size: 12px;
      }

      ::v-deep .ql-editor.ql-blank::before {
        color: #c0c4cc;
        content: attr(data-placeholder);
        font-style: normal;
        font-size: 12px;
        left: 15px;
        pointer-events: none;
        position: absolute;
        right: 15px;
      }
    }

    .toolsBox {
      display: flex;
      justify-content: space-between;
      align-items: flex-start;
      width: 80%;

      ::v-deep audio {
        margin-top: 10px;
        height: 35px;
        width: 270px;
      }

      .audioBox {
        margin-top: 10px;
        line-height: 35px;
        height: 35px;
        display: flex;
        align-items: center;
      }
    }

    //多音字结束

    .avatar-uploader .el-upload {
      border: 1px dashed #d9d9d9;
      border-radius: 6px;
      cursor: pointer;
      position: relative;
      overflow: hidden;
    }

    .avatar-uploader .el-upload:hover {
      border-color: #409eff;
    }

    .avatar-uploader-icon {
      font-size: 28px;
      color: #8c939d;
      width: 160px;
      height: 90px;
      line-height: 80px;
      text-align: center;
      border: 1px solid #dcdfe6;
      margin-bottom: 20px;
    }

    .avatar {
      width: 160px;
      height: 90px;
      display: block;
    }

    .btn {
      margin-left: 10px;
    }

    .footer {
      text-align: center;
      margin-top: 25px;
    }
  }
}
</style>
